import React, {Component, useEffect, useState} from 'react';
import {app} from "app/app";
import 'assets/sass/login/Login.scss';
import {images} from "assets/img/common/common";
import { AlertFactory } from '../../models/alerts/AlertFactory';

const ConfirmAccountController = ({location, history}) => {
    const [showContent, setShowContent] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const params = location.search.slice(1).split("&");
    let user;
    let token;

    useEffect(() => {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            setIsMobile(true);
        }
    });

    if (params.length > 1) {
        user = params[0].split("=")[1];
        token = params[1].split("=")[1];
    }

    const goToDownloadApp = () => {
        window.location = 'https://buenbit.onelink.me/A1PW/55a3c7e9';
    };

    const content = <div className="verification-email-landing">
        <div className={`verification-email-landing-container ${!isMobile && 'verification-email-desktop'}`}>
            <img className="verification-email-logo" src={images.logo} alt={app.productName()}/>
            <div className="verification-email-landing-container-box">
                <img className="verification-email-check" src={images.circleCheck} alt={app.productName()}/>
                <h2>Confirmaste tu email con éxito</h2>
                <p>Escanea el código QR para continuar con tu registro desde la app de Buenbit</p>
                {
                isMobile
                ?   <div className="verification-email-button">
                        <button className={`cta-button`}
                            onClick={() => goToDownloadApp()}>
                        Descargar app
                        </button>
                    </div>
                :   <div className="verification-email-qr">
                        <img src={images.qrStores} alt={app.productName()}/>
                    </div>
                }
            </div>
        </div>
    </div>;

    app.apiClient().confirmAccount(user, token, response => {
        if (response.hasError()) {
            alert("La confirmación falló. Intentelo nuevamente más tarde")
        } else {
            setShowContent(true);
        }
    });

    return showContent ? content : <div />;
};

export default ConfirmAccountController;

